import React, { useState, useEffect } from "react";
import eventEmitter from "../../shared/events";
import { EVENT_AJAXING, EVENT_DONE_AJAXING } from "../../shared/data";

const LoadingIndicator = () => {
    const [isLoading, setIsLoading] = useState(false);
    let isMounted = false;
    let doneTimeout;

    const isAjaxing = () => {
        clearTimeout(doneTimeout);
        setIsLoading(true);
    };

    const doneAjaxing = () => {
        doneTimeout = setTimeout(() => {
            if (isMounted) {
                setIsLoading(false);
            }
        }, 1000);
    };

    useEffect(() => {
        isMounted = true;
        eventEmitter.on(EVENT_AJAXING, isAjaxing);
        eventEmitter.on(EVENT_DONE_AJAXING, doneAjaxing);

        return () => {
            isMounted = false;
            clearTimeout(doneTimeout);
            eventEmitter.removeListener(EVENT_AJAXING, isAjaxing);
            eventEmitter.removeListener(EVENT_DONE_AJAXING, doneAjaxing);
        };
    }, []);

    return (
        <>
            {isLoading && (
                <div className="global-loader">
                    <div className="load-bar"></div>
                </div>
            )}
        </>
    );
};

export default LoadingIndicator;
